export default "__VITE_ASSET__DLhl5Rn4__"